// extracted by css-extract-rspack-plugin
export default {"transitionColor":"KxxLs","transitionThemeChange":"QjQnf"};